import { useQuery } from 'react-query';

import { OrganisationWithCounts } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetAllOrganisations = () => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<OrganisationWithCounts[]>(
    'all-orgs',
    async () => {
      const url = new URL(`${APIBaseChronos}/api/org/all`);

      try {
        const res = await fetch(url.toString(), fetchConfigGET);
        return await res.json();
      } catch (err) {
        console.error(err);
      }
    },
    {
      refetchInterval: (organisations) =>
        organisations?.some(({ deletionStatus }) => ['queued', 'inProgress'].includes(deletionStatus ?? ''))
          ? 5_000
          : false,
    },
  );
};
